import { render, staticRenderFns } from "./preFaturamento.vue?vue&type=template&id=1d657f3e"
import script from "./preFaturamento.ts?vue&type=script&lang=js&external"
export * from "./preFaturamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d657f3e')) {
      api.createRecord('1d657f3e', component.options)
    } else {
      api.reload('1d657f3e', component.options)
    }
    module.hot.accept("./preFaturamento.vue?vue&type=template&id=1d657f3e", function () {
      api.rerender('1d657f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/financeiro/preFaturamento.vue"
export default component.exports